import React from "react";

import crossImg from "../images/xs.svg";

import "../styles/slide-out-modal.scss";

const SlideOutModal = ({
  children,
  title,
  onClose,
  buttons,
  stepSection,
  className,
  width,
}) => {
  const buttonsArray = Array.isArray(buttons) ? buttons : [buttons];

  return (
    <div className={`slide-out-modal ${className ? className : ""}`}>
      <div className="background" />
      <div className="popup" style={{ width: width || 720 }}>
        {!children && (
          <div className="spinner-container">
            <div className="spinner">
              <div className="bounce1" />
              <div className="bounce2" />
              <div className="bounce3" />
            </div>
          </div>
        )}
        <div className="header">
          <div className="control-section">
            <div className="close-icon">
              <img src={crossImg} alt="close" onClick={onClose} />
            </div>
            {stepSection && <div className="step-counter">{stepSection}</div>}
          </div>
          <div className="title">{title}</div>
          <div className="delimeter" />
        </div>
        <div className="popup-body">{children}</div>
        {buttons && (
          <div className="footer">
            <div className="delimeter" />
            {buttonsArray.map((b, i) => React.cloneElement(b, { key: i }))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SlideOutModal;
